import { CATALOG_PUBLISH_SAVE_SCOPE, SITE_SETTINGS_SAVE_SCOPE, useSaveButtonLabel } from './useSaveButtonLabel';

export default function AdminCatalogTop({
  catalogDbActive,
  adminUsername,
  onLogout,
  onPublishCatalog,
  onSaveSiteSettings,
  adminTab,
  saving,
  dirty,
  dataSource,
  loading,
}) {
  const showOffline = !loading && !catalogDbActive && dataSource !== 'mysql';
  const onSiteTab = adminTab === 'site';
  const siteSave = useSaveButtonLabel('Save site settings', { scope: SITE_SETTINGS_SAVE_SCOPE });
  const catalogPublish = useSaveButtonLabel('Publish', {
    scope: CATALOG_PUBLISH_SAVE_SCOPE,
    savedLabel: 'Published ✓',
  });

  let statusTone = 'ok';
  let statusLabel = 'Synced';
  if (saving || siteSave.isSaving) {
    statusTone = 'busy';
    statusLabel = 'Saving';
  } else if (siteSave.isSaved || catalogPublish.isSaved) {
    statusTone = 'ok';
    statusLabel = 'Saved';
  } else if (dirty && !onSiteTab) {
    statusTone = 'pending';
    statusLabel = 'Pending';
  } else if (showOffline) {
    statusTone = 'warn';
    statusLabel = 'Offline';
  } else if (catalogDbActive) {
    statusLabel = 'Live';
  }

  const primaryAction = onSiteTab ? onSaveSiteSettings : onPublishCatalog;
  const primaryBusy = onSiteTab ? siteSave.isSaving : saving || catalogPublish.isSaving;
  const primarySaved = onSiteTab ? siteSave.isSaved : catalogPublish.isSaved;
  const primaryLabel = onSiteTab
    ? siteSave.label
    : saving
      ? 'Saving…'
      : catalogPublish.isSaved
        ? catalogPublish.label
        : dirty
          ? 'Publish now'
          : catalogPublish.label;

  return (
    <div className="admin-shell-top">
      <div className="admin-shell-top__row">
        <div className="admin-shell-top__brand">
          <span className="admin-shell-top__kicker">Saloni Designs</span>
          <h1 className="admin-shell-top__title">Store admin</h1>
        </div>

        <div className="admin-shell-top__tools">
          <span
            className={`admin-shell-top__pill admin-shell-top__pill--${statusTone}`}
            title={
              onSiteTab
                ? 'Site settings — click Save site settings after editing'
                : catalogDbActive && !saving && !dirty
                  ? 'Catalog changes save automatically'
                  : undefined
            }
          >
            <span className="admin-shell-top__pill-dot" aria-hidden />
            {statusLabel}
          </span>

          <button
            type="button"
            className={`btn btn-sm admin-shell-top__publish${primarySaved ? ' btn-success' : ' btn-primary'}`}
            onClick={primaryAction}
            disabled={primaryBusy}
          >
            {primaryLabel}
          </button>

          <div className="admin-shell-top__account">
            <span className="admin-shell-top__avatar" aria-hidden>
              {(adminUsername || 'A').charAt(0).toUpperCase()}
            </span>
            <span className="admin-shell-top__name">{adminUsername || 'admin'}</span>
            <button type="button" className="btn btn-link btn-sm admin-shell-top__signout" onClick={onLogout}>
              Sign out
            </button>
          </div>
        </div>
      </div>

      {onSiteTab ? (
        <p className="admin-shell-top__notice" role="status">
          <strong>Site tab:</strong> use <strong>Save site settings</strong> (or Save in the bar below). Top Publish only applies to products &amp; categories.
        </p>
      ) : null}
      {showOffline ? (
        <p className="admin-shell-top__notice" role="status">
          Catalog is not loading from your live store. Open admin on your published website and refresh.
        </p>
      ) : null}
    </div>
  );
}
